import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { Observable } from 'rxjs'
import { UserService } from './user.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        private userService: UserService,
    ) {}

    intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
        if ( !this.userService.validate() ) this.userService.deny()

        const updatedRequest = request.clone({
        	headers: request.headers.set('Authorization', `bearer ${this.userService.token}`)
        })

        return next.handle(updatedRequest)

    }
}
